<template >
    <div>
    <section-definition
    v-if="insert_form == false"
    :extraOptions="options"
    :title="page.title"
    :icon="page.icon"
    :supportdata="supportdatas"
    :industrydata="industrydata"
    @supportdata="supportdata($event)"
    @industrydata="industrydatas($event)"
    @editiconPage="bulkassign"
    @openFilter="isFilter"
    @downloadData="exportpopup"
    @plusPage="addtickets"
    @dynamicFilter="dynamicFilter($event)"
    ></section-definition>
    <div v-if="insert_form == false" class="main_view_ticket">
    <div class="ticket_nav_view">
    <div class="tab_view">
    <div
    v-for="(item, i) in items"
    :key="i"
    @click="tab_select(item.catagory)"
    :class="item.value"
    >
    <div v-if="item.catagory === 'All'" class="tab_icon">
    <i class="fa fa-globe" aria-hidden="true"></i>
    </div>
    <div v-if="item.catagory === 'Open'" class="tab_icon">
    <i class="fa fa-envelope-open-o" aria-hidden="true"></i>
    </div>
    <div v-if="item.catagory === 'Closed'" class="tab_icon">
    <i class="fa fa-envelope-o" aria-hidden="true"></i>
    </div>
    <div v-if="item.catagory === 'Pending'" class="tab_icon">
    <i class="fa fa-pause" aria-hidden="true"></i>
    </div>
    <div v-if="item.catagory === 'Resolve'" class="tab_icon">
    <i class="fa fa-retweet" aria-hidden="true"></i>
    </div>
    <div v-if="item.catagory === 'Unresolve'" class="tab_icon">
    <i class="fa fa-recycle" aria-hidden="true"></i>
    </div>
    <div v-if="item.catagory === 'On Hold'" class="tab_icon">
    <i class="fa fa-play-circle" aria-hidden="true"></i>
    </div>
    <div v-if="item.catagory === 'Over Due'" class="tab_icon">
    <i class="fa fa-list-alt" aria-hidden="true"></i>
    </div>
    <div v-if="item.catagory === 'Unassigned'" class="tab_icon">
    <i class="fa fa-chain-broken" aria-hidden="true"></i>
    </div>
    <div class="tab_txt">{{ item.catagory }}</div>
    </div>
    </div>
    </div>
   
    <div class="ticket_body_view">
    <v-data-table
    :headers="headers"
    :items="Ticketsdata"
    class="elevation-1"
    hide-default-header
    :headers-length="10"
    hide-actions
    >
    <template v-slot:headers="props" id="table-scroll">
    <tr style="height: 30px">
    <th style="height: 32px; width: 50px">
    <v-checkbox
    @change="select_all()"
    style="padding-top: 12px; padding-left: 2px; height: 50px"
    v-model="select_check"
    color="primary"
    >
    </v-checkbox>
    </th>
    <th
    style="max-width: 150px"
    v-for="head in props.headers"
    :key="head.name"
    >
    {{ head.text }}
    </th>
    <th style="text-align: center">Action</th>
    </tr>
    </template>
    <template v-slot:items="props">
    <td>
    <v-checkbox
    v-model="props.item.checker"
    primary
    @change="newValue(props.item)"
    hide-details
    color="primary"
    ></v-checkbox>
    </td>
    <td
    style="min-width: 170px"
    class="checkEmpty"
    v-for="(property, index) in Object.keys(props.item)"
    :key="index"
    >
    <p style="margin-top: 14px;max-width: 170px;overflow: hidden; white-space: nowrap;text-overflow: ellipsis;" v-if="property !== 'checker'">
    {{
    props.item[property] == "" ||
    props.item[property] == null ||
    props.item[property] == undefined
    ? "N/A"
    : props.item[property]
    }}
    </p>
    <div class="icon_section">
    <template v-if="property == 'checker'">
    <v-icon
    v-show="page.canedit"
    small
    class="mr-4"
    @click="ticket_info(props.item)"
    >info</v-icon
    >
    <v-icon
    v-show="page.userassign"
    color="blue"
    @click="assignAgent(props.item)"
    title="Agent Assign"
    small
    class="mr-4"
    >queue
    </v-icon>
    <v-icon
    color="red"
    @click="deletepopup(props.item)"
    title="Agent Assign"
    small
    class="mr-4"
    >delete
    </v-icon>
    </template>
    </div>
    </td>
    </template>
    </v-data-table>
    <div class="pagination-div theme--light" style="height: 50px">
    <div flex id="row-selector">
    <div id="page-control">
    <span
    >{{ (currentPage - 1) * perPage + 1 }}-{{ endPage }} of
    {{ totalRows }}</span
    >
    <span class="action-icon">
    <v-icon medium class="move-page" @click="moveNextPage(false)"
    >chevron_left</v-icon
    >
    <v-icon medium class="move-page" @click="moveNextPage(true)"
    >chevron_right</v-icon
    >
    </span>
    </div>
    </div>
    </div>
    </div>
   
    <v-snackbar
    v-model="snackbar.show"
    :bottom="true"
    :right="true"
    :timeout="snackbar.timeout"
    >
    {{ snackbar.text }}
    <v-btn color="pink" flat @click="snackbar.show = false">Close</v-btn>
    </v-snackbar>
    </div>
   
   
   
    <v-navigation-drawer
    fixed
    disable-resize-watcher
    right
    :value="isFilterOpen"
    >
    <v-toolbar small color="secondary" style="color: white">
    <v-toolbar-title>Filter</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn icon flat color="white" @click="isFilterOpen = false">
    <i class="fas fa-close"></i>
    </v-btn>
    </v-toolbar>
    <div
    class="flex-column justify-sb height-100-exclude-toolbar overflow-auto"
    >
    <v-container class="sidenavContainer">
   
    <div v-for="field in dynamicFields" :key="field.model">
    <div class="autocompleteDiv" v-if="field.fieldType == 'SelectList'">
    <v-select
    :items="field.values"
    :label="field.label"
    v-model="field.value"
    item-text="name"
    item-value="value"
    multiple
    ></v-select>
    </div>
    <div class="autocompleteDiv" v-if="field.fieldType == 'TextInput' && field.input_type == 'Text'">
    <v-text-field
    v-model="field.value"
    :label="field.label"
    small
    ></v-text-field>
    </div>
    <div class="autocompleteDiv" v-if="field.fieldType == 'DatePicker' && field.input_type == 'DateTime'">
    <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :return-value.sync="dates"
    transition="scale-transition"
    offset-y
    min-width="auto"
    >
   
    <template v-slot:activator="{ on, attrs }">
    
    </template>
    <v-date-picker
    v-model="date"
    no-title
    scrollable
    >
    <v-text-field
    v-model="dateRangeText"
    label="Date range"
    prepend-icon="mdi-calendar"
    readonly
    ></v-text-field>
    <v-spacer></v-spacer>
    <v-btn
    text
    color="primary"
    @click="menu = false"
    >
    Cancel
    </v-btn>
    <v-btn
    text
    color="primary"
    @click="$refs.menu.save(date)"
    >
    OK
    </v-btn>
    </v-date-picker>
   
    </v-menu>
    </div>
    </div>
   
    </v-container>
    <v-container row class="sidenavFooter">
    <v-btn flat @click="reset()">Reset</v-btn>
    <v-spacer></v-spacer>
    <v-btn color="primary" @click="fetchfilterdata()">Filter</v-btn>
    </v-container>
    </div>
    </v-navigation-drawer>
   
    <v-dialog v-model="isShowAgentAssign" max-width="400px">
    <v-form ref="refassign">
    <v-card>
    <v-toolbar color="primary" dark>
    <v-toolbar-title>Assign Ticket</v-toolbar-title>
    </v-toolbar>
    <v-container
    id="scroll-target"
    style="max-height: 350px"
    class="scroll-y"
    >
    <template>
    <v-autocomplete
    v-model="assignedDetails.user"
    :items="agents"
    label="Agent"
    required
    persistent-hint
    :allow-overflow="false"
    ></v-autocomplete>
    </template>
    </v-container>
    <v-card-actions>
    <v-spacer></v-spacer>
    <v-btn color="light" flat @click="closeAssign()">Cancel</v-btn>
    <v-btn color="primary" @click="submitAssign()">Save</v-btn>
    </v-card-actions>
    </v-card>
    </v-form>
    </v-dialog>
    <v-dialog v-model="bulkassign_popup" max-width="400px">
    <v-form ref="refassign">
    <v-card>
    <v-toolbar color="primary" dark>
    <v-toolbar-title>Bulk Assign</v-toolbar-title>
    </v-toolbar>
    <v-container
    id="scroll-target"
    style="max-height: 350px"
    class="scroll-y"
    >
    <template>
    <v-autocomplete
    v-model="bulk_assign"
    :items="agents"
    label="Agent"
    required
    persistent-hint
    :allow-overflow="false"
    ></v-autocomplete>
    </template>
    </v-container>
    <v-card-actions>
    <v-spacer></v-spacer>
    <v-btn color="light" flat @click="bulkassign_popup = false"
    >Cancel</v-btn
    >
    <v-btn color="primary" @click="submitBulkAssign()">Save</v-btn>
    </v-card-actions>
    </v-card>
    </v-form>
    </v-dialog>
    <v-dialog v-model="delete_popup" max-width="400px">
    <v-form ref="refassign">
    <v-card>
    <v-toolbar color="primary" dark>
    <v-toolbar-title>Delete Ticket</v-toolbar-title>
    </v-toolbar>
    <v-container
    id="scroll-target"
    style="max-height: 350px"
    class="scroll-y"
    >
    Do you delete this Ticket?
    </v-container>
    <v-card-actions>
    <v-spacer></v-spacer>
    <v-btn color="light" flat @click="deleteCancelpopup()"
    >Cancel</v-btn
    >
    <v-btn color="primary" @click="deleteTicket()">Delete</v-btn>
    </v-card-actions>
    </v-card>
    </v-form>
    </v-dialog>
    <template>
    <v-dialog v-model="export_popup" max-width="400px" scrollable>
    <v-card>
    <v-toolbar dark color="primary">
    <div class="asdff">
    <div>
    <div style="font-size: large; font-weight: 600">
    Export Data
    </div>
    </div>
    <div style="padding-top: 4px">
    <v-icon
    color="light"
    flat
    style="font-size: 20px"
    @click="export_popup = false"
    >fa-times</v-icon
    >
    </div>
    </div>
    </v-toolbar>
    <v-card-text>
    <v-form ref="refassign">
    <v-container grid-list-md>
    <div>
    <div class="exportflex">
    <div class="export" @click="filedownload('csv')">
    <v-icon class="hovericon" size="60"
    >fa fa-file-code-o
    </v-icon>
    <div
    style="
    font-size: 20px;
    color: #2c3e50;
    font-weight: 800;
    padding: 5px;
    "
    >
    CSV
    </div>
    </div>
    <div class="export" @click="filedownload('txt')">
    <v-icon class="hovericon" size="60">fa-file-text </v-icon>
    <div
    style="
    font-size: 20px;
    color: #2c3e50;
    font-weight: 800;
    padding: 5px;
    "
    >
    TXT
    </div>
    </div>
    </div>
    </div>
    </v-container>
    </v-form>
    </v-card-text>
    <v-card-actions class="modal-footer-sticky">
    <v-spacer></v-spacer>
    </v-card-actions>
    </v-card>
    </v-dialog>
    </template>
   
   
    <v-container fluid grid-list-xl page style="padding-top: 10px">
    <inserforms
    v-if="insert_form"
    :page_="true"
    model="TICKET"
    @customform="customform_insert($event)"
    ></inserforms>
    </v-container>
    </div>
   </template>
    
   <script>
   import { mapGetters } from "vuex";
   import inserforms from "./InsertAsterLead.vue";
   export default {
    components: { inserforms },
    data() {
    return {
    dates: ['2019-09-10', '2019-09-20'],
    templatedata: [],
    section_tab_change: "All",
    page: {
    title: "Tickets",
    icon: "fa fa-bullhorn fa-2x",
    canedit: false,
    userassign: false,
    },
    supportdatas: [],
    tab: null,
    items: [
    {
    catagory: "All",
    value: "tab_button",
    },
    {
    catagory: "Open",
    value: "tab_button",
    },
    {
    catagory: "Pending",
    value: "tab_button",
    },
    {
    catagory: "Resolve",
    value: "tab_button",
    },
    {
    catagory: "Unresolve",
    value: "tab_button",
    },
    {
    catagory: "Closed",
    value: "tab_button",
    },
    {
    catagory: "On Hold",
    value: "tab_button",
    },
    {
    catagory: "Over Due",
    value: "tab_button",
    },
    {
    catagory: "Unassigned",
    value: "tab_button",
    },
    ],
    headers: [],
    HeadersFieldProperty:[],
    industrydata: [],
    Ticketsdata: [],
    CloneTicketdata: [],
    agents: [],
    perPage: 8,
    currentPage: 1,
    totalRows: 0,
    endPage: 0,
    currentsupport: "",
    options: {
    filter: true,
    plus: false,
    editicon: false,
    uploadicon: false,
    downloadicon: false,
    selectedcurrent: "",
    },
    current_tab: "",
    temp_index: [],
    bulk_edit_arr: [],
    select_check: false,
    isShowAgentAssign: false,
    assignedDetails: {},
    bulkassign_popup: false,
    bulk_assign: "",
    export_popup: false,
    exportType: ["CSV", "Txt(Tab-Delimited)"],
    insert_form: false,
    downloadData: [],
    snackbar: {
    show: false,
    timeout: 6000,
    text: "",
    },
    isFilterOpen: false,
    dynamicFields: [],
    mergepopup: false,
    user_email:JSON.parse(localStorage.apiInfo).user_email,
    delete_popup:false,
    delete_id:"",
    isfilterval:false
    };
    },
    computed: {
    ...mapGetters(["form"]),
    dateRangeText () {
    return this.dates.join(' ~ ')
    }
    },
    methods: {
    ticket_info(val) {
    console.log("val", val);
    // let obj = JSON.parse(localStorage.ticket_templet);
    let userdata = this.CloneTicketdata.find(
    (elm) => elm.ticket_id == val.ticket_id
    );
    let obj = {};
    obj.ticket_id = val.ticket_id;
    obj.phone_number = userdata.phone_number;
    obj.user = userdata.user;
    localStorage.setItem("ticket_templet", JSON.stringify(obj));
   
    this.$router.push({
    name: "crm/ticketDetail",
    });
    },
    newValue(row) {
    var scope = this;
    let id = row["ticket_id"];
    if (!scope.bulk_edit_arr.includes(id)) {
    scope.bulk_edit_arr.push(id);
    } else {
    const index = scope.bulk_edit_arr.indexOf(id);
    if (index > -1) {
    scope.bulk_edit_arr.splice(index, 1);
    }
    }
    if (this.Ticketsdata.length == this.bulk_edit_arr.length) {
    scope.select_check = true;
    } else {
    scope.select_check = false;
    }
    if (this.bulk_edit_arr.length > 0) {
    scope.options.editicon = true;
    } else {
    scope.options.editicon = false;
    }
    },
    select_all() {
    var scope = this;
    let id = "";
    if (scope.select_check) {
    scope.bulk_edit_arr = [];
    for (let i = 0; i < scope.Ticketsdata.length; i++) {
    scope.Ticketsdata[i].checker = true;
    id = scope.Ticketsdata[i]["ticket_id"];
    scope.bulk_edit_arr.push(id);
    }
    scope.options.editicon = true;
    } else {
    for (let j = 0; j < scope.Ticketsdata.length; j++) {
    scope.Ticketsdata[j].checker = false;
    }
    scope.bulk_edit_arr = [];
    scope.options.editicon = false;
    }
    },
    tab_select(val) {
    // this.section_tab_change = val;
    let scope = this
    scope.currentPage = 1
    scope.isfilterval = false;
    for (let i = 0; i < scope.items.length; i++) {
    const element = scope.items[i];
    if (element.catagory === val) {
    element.value = "tab_button_swap";
    } else {
    element.value = "tab_button";
    }
    }
    scope.class_changer = "tab_button_swap";
    
    scope.currentsupport = val;
    scope.supportdata(scope.currentsupport);
    },
   
   
    moveNextPage(next) {
    const scope = this;
    if (next && scope.totalRows >= scope.currentPage * scope.perPage + 1) {
    scope.currentPage = scope.currentPage + 1;
    scope.supportdata(scope.currentsupport);
    } else if (!next && scope.currentPage !== 1) {
    scope.currentPage = scope.currentPage - 1;
    scope.supportdata(scope.currentsupport);
    }
    },
    assignAgent(ticketData) {
    const scope = this;
    scope.assignedDetails = { ...ticketData };
    // scope.assignedDetails.template_name = scope.currentsupport;
    scope.isShowAgentAssign = true;
    },
    closeAssign() {
    const scope = this;
    scope.assignedDetails = {};
    scope.isShowAgentAssign = false;
    // scope.$refs.refassign.resetValidation();
    },
    submitAssign() {
    const scope = this;
    const assignDetails = {
    ticket_id: scope.assignedDetails["ticket_id"],
    assign: scope.assignedDetails["user"],
    user:scope.user_email
    };
    scope.$store
    .dispatch("AssignTicket", assignDetails)
    .then((response) => {
    if (response.statusCode === 200) {
    scope.showSnackBar("Ticket assigned successfully");
    scope.assignedDetails = {};
    scope.isShowAgentAssign = false;
    scope.$refs.refassign.resetValidation();
    scope.supportdata(this.currentsupport);
    } else {
    scope.showSnackBar("Ticket assigned to failed!");
    }
    })
    .catch(() => {
    scope.showSnackBar("Ticket assigned to agent failed!");
    });
    },
    bulkassign() {
    this.bulkassign_popup = true;
    },
    submitBulkAssign() {
    var scope = this;
    var edit_data = {
    assign: scope.bulk_assign,
    bulk_id: scope.bulk_edit_arr,
    user:scope.user_email
    };
    scope.$store
    .dispatch("AssignTicket", edit_data)
    .then(() => {
    scope.bulkassign_popup = false;
    scope.bulk_assign = "";
    scope.bulk_edit_arr = [];
    scope.select_check = false;
    scope.options.editicon = false;
    scope.showSnackBar("Ticket Assign Updated Successfully");
    })
    .catch(function (error) {
    scope.options.editicon = false;
    scope.showSnackBar("error" + error);
    });
    scope.supportdata(scope.currentsupport);
    },
    exportpopup() {
    this.export_popup = true;
    },
    filedownload(value) {
    console.log(value)
    let scope = this
    const payload = {
    status:"",
    skip: scope.perPage * (scope.currentPage - 1),
    take: scope.perPage,
    download:true
    };
    let filterData = {};
    if(scope.isfilterval == true){
    scope.dynamicFields.forEach((data) => {
    if(data.value !=""){
    filterData[data.model] = data.value
    }
    
    });
    payload.payload={dynamicfilter:filterData}
    }else{
    if (
    scope.currentsupport != "All" &&
    scope.currentsupport != ""
    ) {
    
    if( scope.currentsupport == "Unassigned"){
    payload.status = "unassign"
    }else if( scope.currentsupport =="Unresolve"){
    payload.status = "pending,hold,overdue,in_progress,unassign"
    }else if( scope.currentsupport =="On Hold"){
    payload.status = "hold"
    }else{
    payload.status = scope.currentsupport.replace(" ", "_").toLowerCase()
    }
    
    }
    }
    
    scope.$store
    .dispatch("GetAsterSupportData",{download:true})
    .then((response) => {
    let datas= response.data[0].others;
   
    
   
    if (value == "csv") {
    let csv = "";
    for (let row = 0; row < datas.length; row++) {
    let keysAmount = Object.keys(datas[row]).length;
    let keysCounter = 0;
   
    if (row === 0) {
    for (let key in datas[row]) {
    csv += key + (keysCounter + 1 < keysAmount ? "," : "\r\n");
   
    keysCounter++;
    }
    keysCounter = 0;
    for (let key in datas[row]) {
    csv +=
    datas[row][key] +
    (keysCounter + 1 < keysAmount ? "," : "\r\n");
    keysCounter++;
    }
    } else {
    for (let key in datas[row]) {
    csv +=
    datas[row][key] +
    (keysCounter + 1 < keysAmount ? "," : "\r\n");
    keysCounter++;
    }
    }
   
    keysCounter = 0;
    }
   
    let link = document.createElement("a");
    link.id = "download-csv";
    link.setAttribute(
    "href",
    "data:text/plain;charset=utf-8," + encodeURIComponent(csv)
    );
    link.setAttribute("download", `${this.currentsupport}.csv`);
    document.body.appendChild(link);
    link.click();
    this.export_popup = false;
    } 
    })
    .catch(function (error) {
    scope.showSnackBar("error1" + error);
    });
    
   
    },
    showSnackBar(message) {
    let scope = this;
    scope.snackbar.text = message;
    scope.snackbar.show = true;
    setTimeout(() => {
    scope.snackbar.text = "";
    }, scope.snackbar.timeout);
    },
    industrydatas(val) {
    this.supportdatas = [];
    this.templatedata.forEach((element) => {
    if (val == element.industry) {
    // console.log(element.template_name);
   
    this.supportdatas.push(element.template_name);
    } else if (val == "All") {
    this.supportdatas.push(element.template_name);
    }
    });
    },
    supportdata(val) {
    let scope = this;
    if(scope.isfilterval == true){
    scope.fetchFilter()
    }else{
    
    scope.currentsupport = val;
    console.log("responseresponseresponseresponse",scope.currentsupport);
    this.$store
    .dispatch("GetAsterSupportField")
    .then((response) => {
    // localStorage.setItem(
    // "ticket_templet",
    // JSON.stringify({ templet: val })
    // );
    // localStorage.setItem(
    // "templetname",
    // JSON.stringify({ templetname: val })
    // );
    var datas = response.fields;
   
    let AsterTicketFields = datas;
   
    let a = datas.map((elm) => elm.model);
    console.log("responseresponseresponseresponse", a);
    let dynamicFields = [];
    if (scope.headers.length === 0) {
    for (let i = 0; AsterTicketFields.length > i; ++i) {
    // AsterTicketFields[i].model = AsterTicketFields[i].model.replace(
    // "_",
    // " "
    // );
    AsterTicketFields[i].label = AsterTicketFields[i].label.replace(
    "_",
    " "
    );
    if (AsterTicketFields[i].show_on_view === true) {
    if (
    AsterTicketFields[i].model === "ticket_id" ||
    AsterTicketFields[i].model === "user" ||
    AsterTicketFields[i].model === "due_date" ||
    AsterTicketFields[i].model === "status" ||
    AsterTicketFields[i].model === "subject"
    ) {
    let key = {
    text:
    AsterTicketFields[i].model == "user"
    ? "Assgin"
    : AsterTicketFields[i].label,
    value:
    AsterTicketFields[i].model == "user"
    ? "user"
    : AsterTicketFields[i].model,
    align: "center",
    sortable: false,
    };
    // scope.headers.push(key);
    if (AsterTicketFields[i].model === "ticket_id") {
    scope.headers.splice(0, 0, key);
    } else if (AsterTicketFields[i].model === "user") {
    scope.headers.splice(1, 0, key);
    } else if (AsterTicketFields[i].model === "due_date") {
    scope.headers.splice(4, 0, key);
    } else if (AsterTicketFields[i].model === "status") {
    scope.headers.splice(3, 0, key);
    } else if (AsterTicketFields[i].model === "subject") {
    scope.headers.splice(2, 0, key);
    }
    scope.HeadersFieldProperty.push(AsterTicketFields[i])
    }
    
   
    }
   
   
   
    if (AsterTicketFields[i].filter === true) {
    
   
    if(AsterTicketFields[i].model == "tags"){
    
    scope.$store
    .dispatch("TicketTags")
    .then((response) => {
    let tag=[]
    if (response.statusCode === 200) {
    tag = response.data.map(e=>{return {name:e.name,value:e.name} }) 
    } 
    AsterTicketFields[i].values =tag
   
    })
    }
    if(AsterTicketFields[i].model == "user"){
    AsterTicketFields[i].label='Assign'
    AsterTicketFields[i].fieldType ="SelectList"
    AsterTicketFields[i].values = scope.agents.filter((e)=>{
    return {name:e, value:e}
    })
    }
    AsterTicketFields[i].value=""
    dynamicFields.push(AsterTicketFields[i]);
    }
    
    }
    scope.dynamicFields = dynamicFields
    }
    
    
   
    if (val !== "") {
    const payload = {
    status:"",
    skip: scope.perPage * (scope.currentPage - 1),
    take: scope.perPage,
    };
    if (
    scope.currentsupport != "All" &&
    scope.currentsupport != ""
    ) {
    
    if( scope.currentsupport == "Unassigned"){
    payload.status = "unassign"
    }else if( scope.currentsupport =="Unresolve"){
    payload.status = "pending,hold,overdue,in_progress,unassign"
    }else if( scope.currentsupport =="On Hold"){
    payload.status = "hold"
    }else{
    payload.status = val.replace(" ", "_").toLowerCase()
    }
    
    }
    scope.$store
    .dispatch("GetAsterSupportData", payload)
    .then((response) => {
    let datas= response.data[0].others;
    
    
    scope.CloneTicketdata = [...datas];
   
    let temparr = [];
    datas.forEach((element) => {
    let tempobj = {};
    scope.headers.forEach((elm) => {
    if (
    element[elm.value] === undefined &&
    elm.value !== "actions"
    ) {
    tempobj[elm.value] = "";
    }
    if (
    elm.value !== "actions" &&
    element[elm.value] !== undefined
    ) {
    if (elm.value == "assgin") {
    elm.value = "user";
    }
   
    tempobj[elm.value] = element[elm.value];
    }
    if(elm.value == "status"){
    let get_status = scope.HeadersFieldProperty.find(e=>e.model == "status").values
    tempobj[elm.value] = get_status.find(e=>e.value== element.status).name
    }
    });
    tempobj.checker = false;
    temparr.push(tempobj);
    });
    
   
    scope.Ticketsdata = temparr;
    scope.select_check = false;
   
    if (response.count !== undefined) {
    scope.totalRows = response.count;
    } else {
    scope.totalRows = 0;
    }
    scope.endPage = scope.currentPage * scope.perPage;
    scope.endPage =
    scope.endPage < scope.totalRows
    ? scope.endPage
    : scope.totalRows;
    
   
    })
    .catch(function (error) {
    scope.showSnackBar("error1" + error);
    });
    }
    })
    .catch(function (error) {
    scope.showSnackBar("error" + error);
    });
    }
    },
    addtickets() {
    let scope = this;
    scope.insert_form = true;
    },
    customform_insert(val) {
    if (val === 201) {
    this.insert_form = false;
    this.supportdata(this.currentsupport);
    this.showSnackBar("Ticket Succesfully created");
    } else if (val === false) {
    this.insert_form = false;
    this.supportdata(this.currentsupport);
    }
    },
    reset() {
    let scope = this;
    scope.isFilterOpen = false;
    scope.currentPage = 1
    scope.dynamicFields.forEach((data) => {
    data.value =""
    });
    scope.tab_select("All")
    
    },
    isFilter() {
    let scope = this;
    scope.isFilterOpen = true;
    },
    fetchfilterdata(){
    let scope = this
    scope.currentPage = 1
    scope.fetchFilter()
    },
    fetchFilter() {
    var scope = this;
    scope.isFilterOpen= false,
    scope.isfilterval = true;
    let filterData = {};
    scope.dynamicFields.forEach((data) => {
    if(data.value !=""){
    filterData[data.model] = data.value
    }
    
    });
    
    const payload = {
    status:"",
    skip: scope.perPage * (scope.currentPage - 1),
    take: scope.perPage,
    payload:{dynamicfilter:filterData}
    };
   
   
    scope.$store
    .dispatch("GetAsterSupportData", payload)
    .then((response) => {
    let datas= response.data[0].others;
    
   
    scope.CloneTicketdata = [...datas];
   
    let temparr = [];
    datas.forEach((element) => {
    let tempobj = {};
    scope.headers.forEach((elm) => {
    if (
    element[elm.value] === undefined &&
    elm.value !== "actions"
    ) {
    tempobj[elm.value] = "";
    }
    if (
    elm.value !== "actions" &&
    element[elm.value] !== undefined
    ) {
    if (elm.value == "assgin") {
    elm.value = "user";
    }
   
    tempobj[elm.value] = element[elm.value];
    }
   
    if(elm.value == "status"){
    let get_status = scope.HeadersFieldProperty.find(e=>e.model == "status").values
    tempobj[elm.value] = get_status.find(e=>e.value== element.status).name
    }
    });
    tempobj.checker = false;
    temparr.push(tempobj);
    });
   
    scope.Ticketsdata = temparr;
    scope.select_check = false;
   
    if (response.count !== undefined) {
    scope.totalRows = response.count;
    } else {
    scope.totalRows = 0;
    }
    scope.endPage = scope.currentPage * scope.perPage;
    scope.endPage =
    scope.endPage < scope.totalRows
    ? scope.endPage
    : scope.totalRows;
    
    for (let i = 0; i < scope.items.length; i++) {
    const element = scope.items[i];
    if (element.catagory === 'All') {
    element.value = "tab_button_swap";
    } else {
    element.value = "tab_button";
    }
    }
    scope.class_changer = "tab_button_swap";
    })
    .catch(function (error) {
    scope.showSnackBar("error1" + error);
    });
    },
   
    deleteTicket(){
    let scope=this
    let query={
    user:scope.user_email,
    ticket_id:scope.delete_id
    }
    scope.$store
    .dispatch("DeleteTicket", query)
    .then((response) => {
    if (response.status === 200) {
    scope.showSnackBar("Ticket Deleted Successfully!");
    scope.supportdata(scope.currentsupport);
    scope.delete_popup = false
    scope.delete_id=""
    } else if(response.status === 204){
    scope.delete_popup = false
    scope.delete_id=""
    scope.showSnackBar("Ticket Unable To Deleted!");
    }else{
    scope.delete_popup = false
    scope.delete_id=""
    scope.showSnackBar("Ticket Delete failed!");
    }
    
    })
    .catch(function (error) {
    scope.showSnackBar("Ticket Delete failed!",error);
    });
    },
    deletepopup(data){
    let scope = this
    scope.delete_id=data.ticket_id
    scope.delete_popup =true
    },
    deleteCancelpopup(){
    let scope= this
    scope.delete_popup = false
    scope.delete_id=""
    }
    },
    mounted() {
    var scope = this;
    scope.tab_select("All")
    // scope.supportdata("All");
   
    scope.agents = JSON.parse(localStorage.getItem("group_users")).filter(e=> e != this.user_email);
    
    setTimeout(
    function () {
    if (
    scope.$store.getters.UserPermissions.indexOf(
    "leadmanagement:tickets:userassign"
    ) !== -1
    ) {
    scope.page.userassign = true;
    }
    if (
    scope.$store.getters.UserPermissions.indexOf(
    "leadmanagement:tickets:edit"
    ) !== -1
    ) {
    scope.page.canedit = true;
    }
    if (
    scope.$store.getters.UserPermissions.indexOf(
    "leadmanagement:tickets:create"
    ) !== -1
    ) {
    scope.options.plus = true;
    }
    if (
    scope.$store.getters.UserPermissions.indexOf(
    "leadmanagement:tickets:download"
    ) !== -1
    ) {
    scope.options.downloadicon = true;
    }
    }.bind(scope),
    1
    );
    },
   };
   </script>
   <style>
   .tab_view {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
   
    padding: 10px 15px 10px 20px;
   }
   
   .tab_button {
    background-color: #cacaca;
    text-align: center;
    display: flex;
    flex-direction: row;
    width: 11%;
    cursor: pointer;
    padding: 5px;
    font-size: 15px;
    border-radius: 8px;
    border: 1px solid #cacaca;
   }
   
   .tab_icon {
    width: 20%;
    text-align: right;
   }
   
   .tab_txt {
    width: 80%;
    text-align: center;
    padding-right: 15px;
   }
   
   .main_view_ticket {
    display: flex;
    flex-direction: column;
   }
   
   .ticket_body_view {
    padding: 10px 20px 10px 20px;
   }
   
   .tab_button_swap {
    background-color: rgb(33, 150, 243);
    color: #fafafa;
    text-align: center;
    display: flex;
    flex-direction: row;
    width: 11%;
    cursor: pointer;
    padding: 5px;
    font-size: 15px;
    border-radius: 8px;
    border: 1px solid #cacaca;
   }
   
   .icon_section {
    align-content: center;
    padding: 0px 0px 0px 33px;
   }
   
   .exportflex {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    padding: 20px;
   }
   
   .export {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    width: 40%;
    height: 130px;
    text-align: center;
    padding: 20px;
    background-color: #cacaca;
    color: #ffffff;
    border-radius: 10px;
   }
   
   .hovericon {
    color: #2c3e50;
    cursor: pointer;
   }
   
   .asdff {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
   }
   </style>